import React from 'react';
import styles from './FormAttention.module.sass'
import PropTypes from 'prop-types';

FormAttention.propTypes = {
    error: PropTypes.string.isRequired
};

function FormAttention(props) {
    return (
        <div key={props.error} className={styles.error}>{props.error}</div>
    );
}

export default FormAttention;